import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Auth, signInWithCustomToken, User } from '@angular/fire/auth';
import { LoaderService } from '@core/components/loader/loader.service';
import { firstValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { GlobalService } from '@core/services/global.service';

export const firebaseConfigResolver: ResolveFn<boolean> = () => {
  return inject(GlobalService)
    .getConfigurations()
    .pipe(map(config => !!config.fireBase.apiKey));
};

export const firebaseAuthResolver: ResolveFn<User> = async () => {
  const fireAuth = inject(Auth);
  if (fireAuth.currentUser) return fireAuth.currentUser;
  const globalService = inject(GlobalService);
  const loaderService = inject(LoaderService);
  const customToken = await firstValueFrom(
    globalService.getFirebaseAuthToken()
  );
  loaderService.show();
  const userCredential = await signInWithCustomToken(
    fireAuth,
    customToken.customToken.result
  );
  loaderService.hide();
  return userCredential.user;
};
